export function setStudiesStorage(wokrspaceId: string, studiesList = []) {
  const validStudies = studiesList.filter(study => study.jobStatus.includes('Viewer OK'));
  const studies = JSON.parse(localStorage.getItem('studies')) || {};
  studies[wokrspaceId] = validStudies;
  localStorage.setItem('studies', JSON.stringify(studies));
}

export function clearStudiesStorage() {
  localStorage.setItem('studies', JSON.stringify({}));
}
